import { render } from "./ImageMessage.vue?vue&type=template&id=f0a547fa&scoped=true&ts=true"
import script from "./ImageMessage.vue?vue&type=script&lang=ts"
export * from "./ImageMessage.vue?vue&type=script&lang=ts"

import "./ImageMessage.vue?vue&type=style&index=0&id=f0a547fa&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0a547fa"]])

export default __exports__